import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { sendGtEvent } from 'apps/auth/analytics/analytics';
import { sendBrazeEvent } from 'apps/auth/analytics/braze';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { BR_SEND_SUCCESS } from 'apps/auth/constants/braze/brazeEvents';
import {
    BR_AMOUNT_SEND_CURRENCY,
    BR_PAYSEND_ID,
    BR_RECEIVING_COUNTRY_CODE,
    BR_SEND_CURRENCY,
    BR_SENDING_COUNTRY_CODE,
    BR_TRX_ID,
} from 'apps/auth/constants/braze/brazeParams';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'apps/auth/constants/formName';
import { GT_SEND_SUCCESS } from 'apps/auth/constants/GoogleAnalyticsEvents';
import { GT_AMOUNT_SEND_CURRENCY, GT_SEND_CURRENCY, GT_TRX_ID, GT_USER_ID } from 'apps/auth/constants/GoogleAnalyticsParamNames';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import SendSMS from './GaSendSMS';

const GaStatusWaiting = (props) => {
    let timerID = null;
    const { headerTitle, statusSmsTitle, statusText, statusDoneTitle } = usePageMessages();
    const { pocketId, cheque } = useExtra();
    const { ballId } = useApp();

    useEffect(() => {
        sendGtEvent(GT_SEND_SUCCESS, {
            [GT_USER_ID]: ballId,
            [GT_TRX_ID]: cheque?.paymentId,
            [GT_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [GT_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
        });
        sendBrazeEvent(BR_SEND_SUCCESS, {
            [BR_TRX_ID]: cheque?.paymentId,
            [BR_SEND_CURRENCY]: cheque?.amountFromCurrency,
            [BR_AMOUNT_SEND_CURRENCY]: cheque?.amountFrom,
            [BR_PAYSEND_ID]: ballId,
            [BR_SENDING_COUNTRY_CODE]: cheque?.fromCountryId,
            [BR_RECEIVING_COUNTRY_CODE]: cheque?.toCountryId,
        });
    }, []);

    const isShowSendSms = props.smsOnSuccessPay && !props.smsOnSuccessPay.sended && props.showSendSMSNotificationBlock;
    return (
        <InfoPage
            animatedIconSuccess
            headerText={headerTitle}
            secondaryText={<DangerouslyHtml dangerouslyHtml={resolveArguments(statusText, `${AUTH_GA_POCKET}${pocketId}`)} />}
            buttonRowCaption={isShowSendSms ? statusSmsTitle : null}
            buttonRowOnClick={() => {
                clearTimeout(timerID);
                props.toggleModal(true, <SendSMS formName={SMS_ON_SUCCESS_PAY_FORM_NAME} />);
            }}
            primaryButtonCaption={statusDoneTitle}
            primaryButtonType="link"
            primaryButtonLink={`${AUTH_GA_POCKET}${pocketId}`}
        />
    );
};

export default connect(null, { toggleModal })(GaStatusWaiting);
